import { useQuery } from "react-query";

import { dropdownValuesService } from "services";

type UsePayoutMethodsQueryProps = {
	options?: any;
};

const usePayoutMethodsQuery = ({ options }: UsePayoutMethodsQueryProps = {}) =>
	useQuery("payoutMethods", dropdownValuesService.getPayoutMethods, {
		...options,
	});

export default usePayoutMethodsQuery;